import { render, staticRenderFns } from "./TaxonomyDataTableRow.vue?vue&type=template&id=85974462&"
import script from "./TaxonomyDataTableRow.vue?vue&type=script&lang=js&"
export * from "./TaxonomyDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports